<template>
  <v-card
    ref="cardRef"
    class="py-1 px-2 mb-1 pw-collection-row"
    :to="{ name: 'Collection', params: { id: collection.id } }"
    @keydown="emit('keydown', $event)"
    @focus="emit('focus', $event)"
    @blur="emit('blur', $event)"
  >
    <v-row density="comfortable">
      <v-col cols="auto" class="d-flex justify-center align-center">
        <avatar-image
          v-if="collection.assignee"
          ref="avatar"
          :user="collection.assignee"
          :size="40"
        />
      </v-col>
      <v-col cols="" class="d-flex flex-column justify-center">
        <sf-text class="text-truncate">{{ collection.name }}</sf-text>
        <sf-secondary-text ref="assignee">
          <template v-if="collection.assignee">
            <span>{{ getFullName(collection.assignee) }}</span>
            <span class="mx-1">-</span>
          </template>
          <span>{{ $t('positions', collection.itemCount) }}</span>
          <template v-if="collection.isArchived">
            <span class="mx-1">-</span>
            <span>{{ $t('common.archived') }}</span>
          </template>
        </sf-secondary-text>
      </v-col>
      <v-col
        v-if="$vuetify.display.mdAndUp"
        ref="created"
        cols="3"
        xl="2"
        class="d-flex justify-end align-center"
      >
        <sf-text v-if="collection.lastModifiedDate">
          {{ formatDate(collection.lastModifiedDate, true) }}
        </sf-text>
      </v-col>
      <v-col
        v-if="$vuetify.display.mdAndUp"
        ref="created"
        cols="3"
        xl="2"
        class="d-flex justify-end align-center"
      >
        <sf-text>
          {{ formatDate(collection.createdDate, true) }}
        </sf-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import AvatarImage from '@/components/AvatarImage.vue'
import SfSecondaryText from '@/components/text/SfSecondaryText.vue'
import SfText from '@/components/text/SfText.vue'
import { getFullName } from '@/helpers'
import { ShopCollection } from '@/types/index'
import { formatDate } from '@/utils/timeFormatHelpers'
import { VueInstance } from '@vueuse/core'
import { PropType, ref, watch } from 'vue'

const props = defineProps({
  collection: {
    type: Object as PropType<ShopCollection>,
    required: true
  },
  isFocused: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  // focus and blur events need to be declared as vue cannot infer them from the template
  'focus',
  'blur',
  'keydown'
])

const cardRef = ref<VueInstance | null>(null)

watch(
  () => props.isFocused,
  () => {
    if (props.isFocused) {
      cardRef.value?.$el.focus()
    } else {
      cardRef.value?.$el.blur()
    }
  }
)
</script>
